// extracted by mini-css-extract-plugin
var _1 = "cg-FVEEs";
export { _1 as "cg" }
